import React from 'react'

import { Card, CardContent, CardMedia, Grid, Typography } from '@mui/material'

const WorkshopCard = ({ title, content, category, imageSrc }) => {
	return (
		<Grid item xs={12} md={3}>
			<Card sx={{ maxWidth: 276, borderRadius: '8px', position: 'relative' }}>
				<CardMedia component="img" height="163" src={imageSrc} alt={title} />
				<CardContent sx={{ textAlign: 'left' }}>
					<Typography variant="h6" sx={{ fontSize: 16, fontWeight: 600, mb: 1 }}>
						{title}
					</Typography>
					<Typography
						component="p"
						sx={{
							bgcolor: 'black',
							display: 'table',
							m: '1rem 0',
							p: '.2rem .6rem',
							fontWeight: 700,
							fontSize: 16,
							color: 'white',
							position: 'absolute',
							top: 0,
							left: 0,
						}}
					>
						{category}
					</Typography>
					<Typography
						component="div"
						sx={{
							fontSize: 14,
							fontWeight: 400,
							lineHeight: '1.2rem',
							'& figure': { display: 'none' },
						}}
						dangerouslySetInnerHTML={{ __html: content }}
					/>
				</CardContent>
			</Card>
		</Grid>
	)
}

export default WorkshopCard
